import React from 'react'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import { Link } from 'gatsby'
import { createShoeUrl } from '../../utils/url-utils'

const Shoe = ({
  content,
  shoe: { id, shoeName, slug, title, thumbnail },
  index,
  length,
}) => {
  const strippedName = shoeName.replace('’', '').trim()

  let editedShoeName
  if (shoeName.includes('Women')) {
    editedShoeName = strippedName.replace('Womens', '').trim()
  } else if (shoeName.includes('Men')) {
    editedShoeName = strippedName.replace('Mens', '').trim()
  } else {
    editedShoeName = shoeName.trim()
  }

  return (
    <div className="u-mt3">
      {length && <h4 className="u-mt1">Number {length - index}</h4>}
      <Link to={createShoeUrl(slug, title)}>
        <h3 id={slug}>{title}</h3>
        {thumbnail && (
          <Img
            className="blog-shoe-image u-m0a u-db"
            alt={title}
            fluid={thumbnail.fluid}
          />
        )}
      </Link>
      {content && (
        <div
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{
            __html: content.childMarkdownRemark.html,
          }}
        />
      )}
      <h4>Find it on shoekicker</h4>
      <div style={{ marginLeft: -16 }}>
        <iframe
          width="480"
          height="240"
          scrolling="no"
          frameBorder="0"
          sandbox="allow-top-navigation allow-same-origin allow-scripts allow-popups"
          src={`https://shoekicker.com/embed/search?shoe=${slug ||
            editedShoeName}`}
        />
      </div>
      <h4>or get it on Amazon</h4>
      <a
        className="u-mt0-5 u-dib"
        href={`https://smile.amazon.com/s/ref=nb_sb_noss_2?url=search-alias%3Daps&field-keywords=${encodeURIComponent(
          editedShoeName
        )}&linkCode=ur2&tag=shoek07-20&sa-no-redirect=1`}
      >
        <button type="button" className="btn__white">
          {' '}
          Get this shoe on Amazon
        </button>
      </a>

      <br />
      <br />
    </div>
  )
}

Shoe.propTypes = {
  content: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string,
    }),
    content: PropTypes.string,
  }),
  shoe: PropTypes.shape({
    id: PropTypes.string,
    shoeName: PropTypes.string,
    slug: PropTypes.string,
    title: PropTypes.string,
    thumbnail: PropTypes.object,
  }),
  index: PropTypes.number,
  length: PropTypes.number,
}

export default Shoe
